import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-custom-radio-button',
  templateUrl: './custom-radio-button.component.html',
  styleUrls: ['./custom-radio-button.component.scss']
})
export class CustomRadioButtonComponent {

  id = Math.random();
  @Input() checked = false;
  @Input() value: any = '';
  @Input() name: string;
  @Output() changed = new EventEmitter<any>();

  onChange() {
    this.changed.emit(this.value);
  }
}
